// extracted by mini-css-extract-plugin
export var headerXL = "SectionTestimonials-module--headerXL--3NmId";
export var headerL = "SectionTestimonials-module--headerL--3sk9v";
export var headerM = "SectionTestimonials-module--headerM--3K_4p";
export var headerS = "SectionTestimonials-module--headerS--36wxp";
export var headerXS = "SectionTestimonials-module--headerXS--12PP7";
export var blogHeaderXL = "SectionTestimonials-module--blogHeaderXL--PUvJu";
export var blogHeaderL = "SectionTestimonials-module--blogHeaderL--rL67y";
export var blogHeaderM = "SectionTestimonials-module--blogHeaderM--2XAxJ";
export var blogHeaderS = "SectionTestimonials-module--blogHeaderS--bVMc0";
export var blogHeaderXS = "SectionTestimonials-module--blogHeaderXS--1tNhD";
export var headerPreamble = "SectionTestimonials-module--headerPreamble--14dMp";
export var preHeader = "SectionTestimonials-module--preHeader--3AW9F";
export var textNormal = "SectionTestimonials-module--textNormal--2u_rx";
export var textSmall = "SectionTestimonials-module--textSmall--1jvHs";
export var textSmallAlternate = "SectionTestimonials-module--textSmallAlternate--2T9Cc";
export var legend = "SectionTestimonials-module--legend--3aA5L";
export var caption = "SectionTestimonials-module--caption--w-v9S";
export var gradientBackground = "SectionTestimonials-module--gradientBackground--2Go9P";
export var ellipsis = "SectionTestimonials-module--ellipsis--1FcWF";
export var globalContainer = "SectionTestimonials-module--globalContainer--64Ebq";
export var maxWidth = "SectionTestimonials-module--maxWidth--1hakX";
export var clipBottom = "SectionTestimonials-module--clipBottom--21RSp";
export var clipTopBottom = "SectionTestimonials-module--clipTopBottom--VxTbC";
export var testimonials = "SectionTestimonials-module--testimonials--1_WJK";
export var ch2 = "SectionTestimonials-module--ch2--1Esir";
export var ch2Container = "SectionTestimonials-module--ch2-container--2YJlI";